<mat-card>
  <mat-card-title>{{ 'users_roles/section/company_roles' | translate }}</mat-card-title>
  <mat-card-content>
    <app-company-roles
      [loading]="loading"
      [roles]="companyRoles"
      (deleteRole)="deleteRole.emit($event)"
      (roleSelected)="roleSelected.emit($event)">
    </app-company-roles>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-title>{{ 'users_roles/section/alcmeon_roles' | translate }}</mat-card-title>
  <mat-card-content>
    <app-alcmeon-roles [loading]="loading" [roles]="alcmeonRoles" (roleSelected)="roleSelected.emit($event)">
    </app-alcmeon-roles>
  </mat-card-content>
</mat-card>
